export default "__VITE_ASSET__5429f15e__"